import * as React from "react";
import { Card, CardContent, CardHeader, Typography, Grid, Divider, List, ListItem, ListItemText } from '@material-ui/core';
import AmountDatetime from '../stats/amountDatetime';
import GeneralStats from '../stats/general'
import CircularProgress from '@material-ui/core/CircularProgress';
import { usePermissions } from 'react-admin';

const styles = {
    amountTime: {
        display: "inline-flex",
        marginRight: "10px",
        width: "900px"
    },
    div2: {
        display: 'block',
        width: "74%",
        float: "left",
        position: "flex"
    },
    table: {
        overflowX: "auto"
    },
    column: {
        flex: "50%"
    },
    row: {
        display: "flex"
    },
    cardSummary: {
        root: {
            minWidth: 275,
            maxWidth: 300,
        },
        bullet: {
            display: 'inline-block',
            margin: '0 2px',
            transform: 'scale(0.8)',
        },
        title: {
            fontSize: 14,
        },
        pos: {
            marginBottom: 12,
        },
    }
};

export default () => {
    if (localStorage.getItem("token") == null) {
        return <CircularProgress style={{ marginLeft: '50%' }} />
    }
    var hoy = new Date();
    var mes = hoy.getMonth();
    let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
    mes = meses[mes];
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (!permissions.includes("dashboard.list")) {
        return (
            <div>
                <div>
                    <Card>
                        <CardHeader title={`Bienvenido a la administración del sistema de pago Speedclean`} />
                        <CardContent>En esta aplicación se puede ver información de los usuarios, transacciones, máquinas y edificios.</CardContent>
                    </Card>
                </div>
            </div>
        );
    }
    // let user = localStorage.getItem('ubs');
    return (
        <div>
            <div>
                <Card>
                    <CardHeader title={`Bienvenido a la administración del sistema de pago Speedclean`} />
                    <CardContent>En esta aplicación se puede ver información de los usuarios, transacciones, máquinas y edificios.</CardContent>
                </Card>
            </div>
            <br />
            <h2>Resumen último mes</h2>
            <div>
                <Grid container alignItems="center" spacing={5} >
                    <Grid item xs={5}>
                        <Card>
                            <CardContent>
                                <Typography styles={styles.cardSummary.title} color="textSecondary" gutterBottom>
                                    Últimos 30 días
                                </Typography>
                                <List className={styles.cardSummary.root}>
                                    <ListItem>
                                        <ListItemText id="days-carga-amount" primary="0" secondary="Carga de saldo" />
                                    </ListItem>
                                    <Divider component="li" />
                                    <ListItem>
                                        <ListItemText id="days-pago-amount" primary="0" secondary="Pagos" />
                                    </ListItem>
                                    <Divider component="li" />
                                    <ListItem>
                                        <ListItemText id="days-pago-counter" primary="0" secondary="Usos de máquina" />
                                    </ListItem>
                                    <Divider component="li" />
                                    <ListItem>
                                        <ListItemText id="days-devolucion-amount" primary="0" secondary="Devoluciones" />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={5}>
                        <Card>
                            <CardContent>
                                <Typography className={styles.cardSummary.title} color="textSecondary" gutterBottom>
                                    Mes actual - {mes}
                                </Typography>
                                <List className={styles.cardSummary.root}>
                                    <ListItem>
                                        <ListItemText id="month-carga-amount" primary="0" secondary="Carga de saldo" />
                                    </ListItem>
                                    <Divider component="li" />
                                    <ListItem>
                                        <ListItemText id="month-pago-amount" primary="0" secondary="Pagos" />
                                    </ListItem>
                                    <Divider component="li" />
                                    <ListItem>
                                        <ListItemText id="month-pago-counter" primary="0" secondary="Usos de máquina" />
                                    </ListItem>
                                    <Divider component="li" />
                                    <ListItem>
                                        <ListItemText id="month-devolucion-amount" primary="0" secondary="Devoluciones" />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
            <h2>Resumen últimos 12 meses</h2>
            <GeneralStats />
            <h2>Resumen detallado último mes</h2>
            <h3>Cargas de saldo por día</h3>
            <div style={styles.row}>
                <div style={styles.column}>
                    <Card>
                        <CardHeader title="Montos - Carga de saldos por día" />
                        <AmountDatetime transactionType="carga" chartId="cargaDatetime" groupId="g3" height={"150"} info="amount" />
                    </Card>
                </div>
                &nbsp;
                &nbsp;
                <div style={styles.column}>
                    <Card>
                        <CardHeader title="Cantidad - Carga de saldos por día" />
                        <AmountDatetime transactionType="carga" chartId="cargaDatetime2" groupId="g3" height={"150"} info="counter" />
                    </Card>
                </div>
            </div>

            <br />
            <h3>Usos de máquina</h3>
            <div style={styles.row}>
                <div style={styles.column}>
                    <Card>
                        <CardHeader title="Montos - Uso de máquinas por día (pagos)" />
                        <AmountDatetime transactionType="pago" chartId="pagoDatetime" groupId="g1" height={"150"} info="amount" />
                    </Card>
                </div>
                &nbsp;
                &nbsp;
                <div style={styles.column}>
                    <Card>
                        <CardHeader title="Cantidad - Uso de máquinas por día (pagos)" />
                        <AmountDatetime transactionType="pago" chartId="pagoDatetime2" groupId="g1" height={"150"} info="counter" />
                    </Card>
                </div>
            </div>
            <br />
            <h3>Devoluciones</h3>
            <div style={styles.row}>
                <div style={styles.column}>
                    <Card>
                        <CardHeader title="Montos - Devoluciones por día" />
                        <AmountDatetime transactionType="devolucion" chartId="devDatetime" groupId="g2" height={"150"} info="amount" />
                    </Card>
                </div>
                &nbsp;
                &nbsp;
                <div style={styles.column}>
                    <Card>
                        <CardHeader title="Cantidad - Devoluciones por día" />
                        <AmountDatetime transactionType="devolucion" chartId="devDatetime2" groupId="g2" height={"150"} info="counter" />
                    </Card>
                </div>
            </div>
        </div>
    )
};